import { ReactText } from "react";
import { FormikHelpers } from "formik";

import { snackbarNotificationsService } from "../notifications/SnackbarNotificationsService";

export type FormFieldsValues = { [key: string]: any };
export interface ErrorContext {
  [key: string]: ReactText;
}

export interface ApiError {
  messageKey: string | undefined;
  context: ErrorContext | undefined;
  formActions: FormikHelpers<FormFieldsValues> | undefined;
  modalTitleKey: string | undefined;
  withForm(values: FormFieldsValues, actions: FormikHelpers<FormFieldsValues>): void;
  withContext(error: ErrorContext): void;
  withErrorMessage(message: string): void;
  withModalTitleKey(titleKey: string): void;
  showErrorInSnackbar(): void;
}

export class BaseApiError implements ApiError {
  formFieldsValues: FormFieldsValues | undefined;
  formActions: FormikHelpers<FormFieldsValues> | undefined;
  context: ErrorContext | undefined;
  messageKey: string | undefined;
  modalTitleKey: string | undefined;

  withForm = (values: FormFieldsValues, actions: FormikHelpers<FormFieldsValues>) => {
    this.formFieldsValues = values;
    this.formActions = actions;
  };

  withContext = (errorContext: ErrorContext) => {
    this.context = errorContext;
  };

  withErrorMessage = (messageKey: string) => {
    this.messageKey = messageKey;
  };

  showErrorInSnackbar = () => {
    snackbarNotificationsService.showError(this.messageKey ?? "default-error", this.context);
  };

  withModalTitleKey(titleKey: string): void {
    this.modalTitleKey = titleKey;
  }
}
